export enum FeatureFlag {
	EnablePaymentGatewayV2 = 'enable_payment_gateway_v2',
	DisableRightSignature = 'disable-rightsignature',
	PlannedBillingDowntime = 'planned_billing_downtime',
	EnableInternationalEcomm = 'enable_international_ecomm',
	EnableBillingAutocomplete = 'enable_billing_autocomplete',
	EnableManagePlanOptimization = 'enable_manage_plan_optimization',
}
